import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center h-screen px-6 bg-gray-200" }
const _hoisted_2 = { class: "w-full max-w-sm p-6 bg-white rounded-md shadow-md" }
const _hoisted_3 = { class: "text-sm text-red-500 font-semibold w-full text-left mt-4" }
const _hoisted_4 = { class: "block" }
const _hoisted_5 = { class: "block mt-3" }
const _hoisted_6 = { class: "mt-10" }
const _hoisted_7 = {
  type: "submit",
  class: "w-full px-4 py-2 text-sm text-center text-white bg-indigo-600 rounded-md focus:outline-none hover:bg-indigo-500"
}

import { ref } from "vue";
import { useRouter } from "vue-router";
import axios from "axios";

// Step 1: Define the base URL from env file

export default /*@__PURE__*/_defineComponent({
  __name: 'AppLogin',
  setup(__props) {

const baseUrl = process.env.VUE_APP_BASE_URL;
const router = useRouter();
const email = ref("");
const password = ref("");
const loading = ref(false);
const error = ref("");

async function login() {
  loading.value = true; // Step 2: Toggle loading state
  try {
    const response = await axios.post(`${baseUrl}/login`, {
      email: email.value,
      password: password.value,
    });
    localStorage.setItem("token", response.data.data.token);
    localStorage.setItem("name", response.data.data.name);
    localStorage.setItem("user_role_id", response.data.data.user_role_id);
    router.push("/dashboard");
  } catch (err) {
    console.error(err);
    error.value = err.response.data.data.error;
  } finally {
    loading.value = false; // Step 2: Toggle loading state
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "flex items-center justify-center" }, [
        _createElementVNode("span", { class: "text-2xl font-semibold text-gray-700" }, "Hela CMS")
      ], -1)),
      _createElementVNode("p", _hoisted_3, _toDisplayString(error.value), 1),
      _createElementVNode("form", {
        class: "mt-1",
        onSubmit: _withModifiers(login, ["prevent"])
      }, [
        _createElementVNode("label", _hoisted_4, [
          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "text-sm text-gray-700" }, "Email", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "email",
            class: "block w-full mt-1 mb-6 border px-4 py-2 border-gray-400 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event))
          }, null, 512), [
            [_vModelText, email.value]
          ])
        ]),
        _createElementVNode("label", _hoisted_5, [
          _cache[3] || (_cache[3] = _createElementVNode("span", { class: "text-sm text-gray-700" }, "Password", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "password",
            class: "block w-full mt-1 mb-6 border px-4 py-2 border-gray-400 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event))
          }, null, 512), [
            [_vModelText, password.value]
          ])
        ]),
        _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"flex items-center justify-between mt-4 hidden\"><div><label class=\"inline-flex items-center\"><input type=\"checkbox\" class=\"text-indigo-600 border-gray-200 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500\"><span class=\"mx-2 text-sm text-gray-600\">Remember me</span></label></div><div><a class=\"block text-sm text-indigo-700 fontme hover:underline\" href=\"#\">Forgot your password?</a></div></div>", 1)),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", _hoisted_7, _toDisplayString(loading.value ? "Signing in..." : "Sign in"), 1)
        ])
      ], 32)
    ])
  ]))
}
}

})